/* global axios */
import ApiClient from './ApiClient';

class PlanosAvisoAPI extends ApiClient {
  constructor() {
    super('planos/aviso', { accountScoped: true });
  }

  dispensar() {
    return axios.post(`${this.url}/dispensar`);
  }
}

export default new PlanosAvisoAPI();
